import BurnCoinBonusIndex from './index';
import BurnCoinBonus from './components/BurnCoinBonus.vue';
import BonusRecord from './components/BonusRecord.vue';
export default {
  path: '/home/entries/BurnCoinBonusIndex',
  component: BurnCoinBonusIndex,
  redirect: '/home/entries/BurnCoinBonus',
  children: [
    { path: '/home/entries/BurnCoinBonus', component: BurnCoinBonus },
    { path: '/home/entries/BonusRecord', component: BonusRecord }
  ]
};
